import Show from 'containers/OrdersExchange/Show';
import List from 'containers/OrdersExchange/List';

export default { List, Show };
